module.exports = __webpack_public_path__ + "static/zoppay@3x-dad83e593c597dfd0e8ecd80a0160e7c.png";